import Constants from '../utils/Constants';

const fetchMolContent = async (src, molContent) => {
  const abortController = new AbortController();
  const timeoutId = setTimeout(() => {
    abortController.abort();
  }, Constants.TIMEOUT_MS);

  try {
    const response = await fetch(src, {
      signal: abortController.signal,
      credentials: 'same-origin',
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mol: molContent }),
    });

    const data = await response.json();
    return data.molfile;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.error(
        `Fetch aborted due to timeout after ${Constants.TIMEOUT_MS}ms`
      );
    } else {
      console.error('Error fetching content:', error);
    }
    return molContent;
  } finally {
    clearTimeout(timeoutId);
  }
};

export default fetchMolContent;
